<template>
    <!-- AppTitle -->
    <AppTitle>
        <template #title>หน่วยงาน</template>
        <template #subtitle> Wanon Niwat Hospital [5S SYSTEM WNH] </template>
        <template #breadcrumb>หน้าหลัก</template>
    </AppTitle>

    <!-- Main Content -->
    <div class="row">
        <div class="col-md-12">
            <div class="tile">
                <!-- <div class="tile-title-w-btn mb-3">
                    <h3 class="title">หน่วยงาน ทั้งหมด</h3>
                    <p>
                        <a class="btn btn-primary icon-btn" href="#" @click="openAddModal">
                            <i class="bi bi-plus-square me-2"></i> Add Item
                        </a>
                    </p>
                </div> -->

                <div class="tile-title-w-btn d-flex justify-content-between align-items-center">
                    <h3 class="title">หน่วยงาน ทั้งหมด</h3>

                    <div class="d-flex align-items-center gap-2">
                        <select v-model="filterKey" class="form-select" style="width: auto;">
                            <option value="name">Name</option>
                        </select>
                        <input type="text" v-model="filterText" placeholder="Search..." class="form-control"
                            style="width: 200px;" />

                        <p>
                            <a class="btn btn-primary icon-btn" href="#" @click="openAddModal">
                                <i class="bi bi-plus-square me-2"></i> Add Item
                            </a>
                        </p>
                    </div>
                </div>


                <Overlay :showOverlay="!items.length" />

                <div class="tile-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Manage</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in filteredItems" :key="item.id">
                                    <th scope="row">{{ index + 1 }}</th>
                                    <td>{{ item.name }}</td>
                                    <td>
                                        <div class="btn-group btn-group-sm" role="group">
                                            <button class="btn btn-warning" @click="openEditModal(item)">
                                                <i class="bi bi-pencil"></i> Edit
                                            </button>
                                            <button class="btn btn-danger" @click="handleDelete(item.id)">
                                                <i class="bi bi-trash"></i> Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Modal -->
                    <div class="modal fade" id="myModal" tabindex="-1" aria-labelledby="exampleModalLabel"
                        aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="exampleModalLabel">
                                        {{ modalMode === 'edit' ? 'Edit Item' : 'Add Item' }}
                                    </h5>
                                    <button type="button" class="btn-close" aria-label="Close"
                                        @click="hideModal"></button>
                                </div>
                                <form @submit.prevent="handleSubmit(editingItem)">
                                    <div class="modal-body">
                                        <div class="mb-3">
                                            <label for="name" class="form-label">Name</label>
                                            <input type="text" id="name" class="form-control" v-model="editingItem.name"
                                                required />
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            @click="hideModal">Close</button>
                                        <button type="submit" class="btn btn-primary" :disabled="isSubmitting">
                                            <span v-if="isSubmitting">
                                                <span class="spinner-border spinner-border-sm me-1" role="status"
                                                    aria-hidden="true"></span>
                                                Saving...
                                            </span>
                                            <span v-else>Save changes</span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Modal } from 'bootstrap';
import { nextTick, ref, reactive, onMounted } from 'vue';
import axiosInstance from '@/utils/axiosInstance';
import {
    showErrorAlert,
    showCreateAlert,
    showUpdateAlert,
    showDeleteAlert,
    showConfirm
} from '@/utils/sweetalert2-utils';
import Overlay from '@/components/Overlay.vue';
import AppTitle from '@/layouts/AppTitle.vue';

const items = ref([]);

const editingItem = reactive({
    name: '',
});

const modalMode = ref('add');

const filterKey = ref('name');
const filterText = ref('');

import { computed } from 'vue';

const filteredItems = computed(() => {
    if (!filterText.value.trim()) return items.value;

    return items.value.filter(item => {
        const value = filterKey.value === 'group.name'
            ? item.group?.name || ''
            : item[filterKey.value] || '';

        return value.toLowerCase().includes(filterText.value.toLowerCase());
    });
});

const fetchData = async () => {
    try {
        const response = await axiosInstance.get('/group');
        items.value = response.data;
    } catch (error) {
        showErrorAlert('ไม่สามารถโหลดข้อมูลได้');
    }
};

const handleDelete = async (id) => {
    const result = await showConfirm();
    if (result.isConfirmed) {
        try {
            await axiosInstance.delete(`/group/${id}`);
            fetchData();
            showDeleteAlert();
        } catch (error) {
            showErrorAlert('เกิดข้อผิดพลาดในการลบรายการ');
        }
    }
};

const isSubmitting = ref(false);

const handleSubmit = async (updatedItem) => {
    isSubmitting.value = true;
    try {
        if (modalMode.value === 'edit') {
            await axiosInstance.put(`/group/${updatedItem.id}`, updatedItem);
            showUpdateAlert();
        } else {
            await axiosInstance.post('/group', updatedItem);
            showCreateAlert();
        }
        fetchData();
        hideModal();
    } catch (error) {
        showErrorAlert('เกิดข้อผิดพลาดในการบันทึกรายการ');
    } finally {
        isSubmitting.value = false;
    }
};

const showModal = () => {
    nextTick(() => {
        const modalElement = document.getElementById('myModal');
        if (modalElement) {
            const modal = new Modal(modalElement);
            modal.show();
        }
    });
};

const hideModal = () => {
    const modalElement = document.getElementById('myModal');
    const modal = Modal.getInstance(modalElement);
    if (modal) modal.hide();
};

const openAddModal = () => {
    modalMode.value = 'add';
    Object.assign(editingItem, { id: null, name: '' });
    showModal();
};

const openEditModal = (value) => {
    modalMode.value = 'edit';
    Object.assign(editingItem, value);
    showModal();
};

onMounted(fetchData);
</script>
